<template>
  <base-modal
    v-if="storage !== null"
    :hide-footer="true"
    :hide-header="true"
    size="lg"
  >
    <material-storage-editor
      :storage="storage"
      :user="user"
      :disabled="!!loading"
      @close-and-update="$emit('closeAndUpdate')"
      @close="$emit('close')"
    />
    <div
      v-if="!!loading"
      class="spinner"
    />
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import MaterialStorageEditor from './MaterialStorageEditor'
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'MaterialStorageEditorModal',
    components: {MaterialStorageEditor, BaseModal},
    mixins: [restApi],
    props: {
        storage: {
            type: Object,
            default: null
        },
        user: {
            type: Object
        }
    },
    data() {
        return {
            loading: 0
        }
    }
}
</script>

<style scoped>

</style>
